import React, { useState, useEffect } from "react";
import "./Css/StaffRights.css";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import Delete from "../assets/delete.svg";
import { Add_designation_text } from "../CommonJquery/WebsiteText";
import {
  check_vaild_save,
  combiled_form_data,
  handleError,
  empty_form,
  formatDateStringdot,
} from "../CommonJquery/CommonJquery";
import {
  server_post_data,
  add_maintainance_data,
  maintainance_data_for_id,
  maintainance_data_dropdown,
  maintainance_status,
} from "../ServiceConnection/serviceconnection.js";
import { useLocation } from "react-router-dom";
function MaintenanceDetails() {
  const location = useLocation();
  const currentUrl = location.pathname.substring(1);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [MaintainanceData, setMaintainanceData] = useState([]);
  const [CarData, setCarData] = useState([]);
  const [CarMaintainance, setCarMaintainance] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [finalData, setFinalData] = useState(true);
  const [type, setType] = useState([]);
  const handleSaveChangesdynamic = async (form_data, url_for_save, flag) => {
    let vaild_data = check_vaild_save(form_data);

    if (vaild_data) {
      setshowLoaderAdmin(true);
      let fd_from = combiled_form_data(form_data, null);
      fd_from.append("flag", flag);
      if (flag === 1) {
        fd_from.append("m_id", CarMaintainance.last_maintenance_id);
      }
      fd_from.append("car_id", CarData.primary_id);
      fd_from.append("booking_id", CarMaintainance.primary_id);
      await server_post_data(url_for_save, fd_from)
        .then((Response) => {
          setshowLoaderAdmin(false);
          if (Response.data.error) {
            handleError(Response.data.message);
          } else {
            empty_form(form_data);
            if (flag === 1) {
              master_data_get_again(CarMaintainance.last_maintenance_id, 1);
            }
            // else {
            //     master_data_get()
            // }
          }
        })
        .catch((error) => {
          console.log(error);
          setshowLoaderAdmin(false);
          handleError(
            Add_designation_text.error_message_toast_handleSaveChangesDyanamic
          );
        });
    }
  };
  const handleSaveChangesdynamic1 = async (id) => {
    let fd_from = new FormData();
    fd_from.append("flag", 3);
    fd_from.append("call_id", id);
    await server_post_data(add_maintainance_data, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          master_data_get();
        }
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
        handleError("network");
      });
  };
  const handleStatusChangesdynamic = async () => {
    let fd_from = new FormData();
    fd_from.append("call_id", CarMaintainance.primary_id);
    fd_from.append("status", 2);
    await server_post_data(maintainance_status, fd_from)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setFinalData(false);
          master_data_get(0);
        }
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
        handleError("network");
      });
  };

  const master_data_get = async () => {
    const url = currentUrl;
    const parts = url.split("/");
    let call_id = 0;
    let flag = 1;
    if (parts.length !== 1) {
      call_id = parts[1];
      flag = 2;
    }
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("m_id", call_id);

    await server_post_data(maintainance_data_dropdown, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setCarData(Response.data.message.car_data);
          setCarMaintainance(Response.data.message.booking_data);
          setType(Response.data.message.maintenance_labels);
          setStaffData(Response.data.message.staff);
          if (Response.data.message.booking_data.last_maintenance_id !== "0") {
            master_data_get_again(
              Response.data.message.booking_data.last_maintenance_id,
              1
            );
          }
          console.log(Response.data.message.booking_data.step_for_maintenance);
          if (Response.data.message.booking_data.step_for_maintenance >= "2") {
            setFinalData(false);
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);
  const master_data_get_again = async (id, flag) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("call_id", id);
    fd.append("flag", flag);
    await server_post_data(maintainance_data_for_id, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setMaintainanceData(Response.data.message.maintainance_data);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        setshowLoaderAdmin(false);
      });
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <Header />
        <div className="page_content">
          <div className="page_content_container">
            <div className="pageCntn_head" style={{ top: "0px" }}>
              <div className="pageNameDiv">
                <p>
                  <p>Maintenance Details</p>
                </p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div>
            </div>

            <div className="page_body container">
              <div className="create_staffRights">
                <div className="row m-0">
                  <div className="personalForm">
                    <div className="carinformation ">
                      <div className="row">
                        {/* Blockquote 1 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote primary">
                            <p>Car Name</p>
                            <footer>-{CarData.car_name}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 2 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote success">
                            <p>Car Modal</p>
                            <footer>-{CarData.model_name}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 3 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote danger">
                            <p>Car Fuel Type</p>
                            <footer>-{CarData.fuel_type}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 4 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote warning">
                            <p>Car Gear Type</p>
                            <footer>-{CarData.gear_type}</footer>
                          </blockquote>
                        </div>
                      </div>
                    </div>

                    {/*----------car info 2------------ */}
                    <div className="carinformation2 ">
                      <div className="row">
                        {/* Blockquote 1 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote primary">
                            <p>Car Number</p>
                            <footer>-{CarData.car_no}</footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 2 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote success">
                            <p> Last Maintenance Date</p>
                            <footer>
                              -{CarMaintainance.last_maintenance_date}
                            </footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 3 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote danger">
                            <p> Next Maintenance Date</p>
                            <footer>
                              -{CarMaintainance.next_maintenance_date}
                            </footer>
                          </blockquote>
                        </div>
                        {/* Blockquote 4 */}
                        <div className="col-md-3 mb-4">
                          <blockquote className="custom-blockquote warning">
                            <p>Last Maintenance K.M.</p>
                            <footer>
                              -{CarMaintainance.last_maintenance_km}
                            </footer>
                          </blockquote>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {MaintainanceData?.length > 0 && (
                  <div className="row mt-5 container flex justify-center align-middle">
                    <table id="myTable" className="display table">
                      <thead>
                        <tr>
                          <th scope="col" className="th3">
                            S. No.
                          </th>
                          <th scope="col">Entry Date</th>
                          <th scope="col">Maintenance Type</th>
                          <th scope="col">Maintenance Note</th>
                          <th scope="col">Status</th>
                        </tr>
                        <tr style={{ height: "25px" }}></tr>
                      </thead>
                      <tbody>
                        {MaintainanceData.map((item, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td className="th3">
                                <div className="recentANme">
                                  <p>{index + 1}</p>
                                </div>
                              </td>
                              <td>
                                <div className="recentContact">
                                  <p>{formatDateStringdot(item.entry_date)}</p>
                                </div>
                              </td>
                              <td>
                                <div className="recentContact">
                                  <p>{item.maintenance_name}</p>
                                </div>
                              </td>
                              <td>
                                <div className="recentContact">
                                  <p>{item.maintenance_note}</p>
                                </div>
                              </td>

                              <td>
                                <button
                                  className="mb-2"
                                  style={{
                                    backgroundColor: "transparent", // Makes button background transparent
                                    border: "none", // Removes the border
                                    padding: 0,
                                  }}
                                  onClick={() =>
                                    handleSaveChangesdynamic1(item.primary_id)
                                  }
                                >
                                  <img src={Delete} alt="Rapid Car Leasing" />
                                </button>
                              </td>
                            </tr>
                            <tr
                              style={{ height: "1rem", boxShadow: "none" }}
                            ></tr>
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {CarMaintainance.step_for_maintenance !== "0" ? (
                  <>
                    {finalData && (
                      <>
                        <form
                          className="createRightsForm"
                          id="createRightsForm"
                        >
                          <div className="row  container">
                            <div className="col-md-3">
                              <div className="inpContainer">
                                <div className="faqDropdown">
                                  <div className="inpContainer">
                                    <label className="no_prsnl_id">
                                      Maintenance Type
                                      <span>*</span>
                                    </label>
                                    <div>
                                      <select
                                        id="maintenance_name"
                                        name="maintenance_name"
                                        className={`trio_mandatory form-control input_field_custom2 input_field_customPadding `}
                                      >
                                        <option value="" hidden>
                                          Select Type
                                        </option>
                                        {type.map((option) => (
                                          <option key={option} value={option}>
                                            {option}
                                          </option>
                                        ))}
                                      </select>
                                      <span className="condition_error"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className={`col-md-6`}>
                              <div className="inpContainer">
                                <label className="no_prsnl_id">
                                  Maintenance Note
                                  <span>*</span>
                                </label>
                                <div>
                                  <input
                                    type="text"
                                    id="maintenance_note"
                                    name="maintenance_note"
                                    className={`  trio_mandatory  input_field_customPadding form-control`}
                                    placeholder="Enter Maintenance Note"
                                  />

                                  <span className="condition_error"></span>
                                </div>
                              </div>
                            </div>

                            <button
                              className="btn btn-primary mt-4 btnSave"
                              onClick={() =>
                                handleSaveChangesdynamic(
                                  "createRightsForm",
                                  add_maintainance_data,
                                  1
                                )
                              }
                            >
                              ADD
                            </button>
                          </div>
                        </form>
                      </>
                    )}
                    {finalData && (
                      <div className="createRightBtnDiv">
                        <button
                          className="btn btn-primary mt-4 Create_Right_Btn btnSave"
                          type="button"
                          onClick={() => handleStatusChangesdynamic()}
                        >
                          Finalized
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <form
                    className="createRightsForm mt-4"
                    id="createRightsFormFirst"
                  >
                    <div className="row  container">
                      <div className="row">
                        <div className="">
                          <div className="inpContainer">
                            <div className="faqDropdown">
                              <div className="inpContainer">
                                <label className="no_prsnl_id">
                                  Staff
                                  <span>*</span>
                                </label>
                                <div>
                                  <select
                                    id="staff_id"
                                    name="staff_id"
                                    className={`trio_mandatory form-control input_field_custom2 input_field_customPadding `}
                                  >
                                    <option value="" hidden>
                                      Select Type
                                    </option>
                                    {staffData.map((option) => (
                                      <option
                                        key={option.primary_id}
                                        value={option.primary_id}
                                      >
                                        {option.admin_name}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="condition_error"></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className={`col-md-6`}>
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              User Name
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                id="user_name"
                                name="user_name"
                                className={`  trio_mandatory  input_field_customPadding form-control`}
                                placeholder="Enter Maintenance Note"
                                value={CarMaintainance.name}
                                readOnly
                              />

                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>
                        <div className={`col-md-6`}>
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Maintenance Type
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                id="maintenance_type"
                                name="maintenance_type"
                                className={`  trio_mandatory  input_field_customPadding form-control`}
                                placeholder="Enter Maintenance Type"
                              />

                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className={`col-md-6`}>
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Maintenance K.M.
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                id="maintenance_mileage_km"
                                name="maintenance_mileage_km"
                                className={`  trio_mandatory  input_field_customPadding form-control`}
                                placeholder="Enter Maintenance K.M."
                              />

                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>
                        <div className={`col-md-6`}>
                          <div className="inpContainer">
                            <label className="no_prsnl_id">
                              Maintenance Note
                              <span>*</span>
                            </label>
                            <div>
                              <input
                                type="text"
                                id="maintenance_starting_note"
                                name="maintenance_starting_note"
                                className={`  trio_mandatory  input_field_customPadding form-control`}
                                placeholder="Enter Maintenance Note"
                              />

                              <span className="condition_error"></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn btn-primary mt-4 btnSave"
                        onClick={() =>
                          handleSaveChangesdynamic(
                            "createRightsFormFirst",
                            add_maintainance_data,
                            4
                          )
                        }
                      >
                        Save
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintenanceDetails;
